export default "__VITE_ASSET__DfgXXFQT__"